import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../../Components/assets/Images/congratsdoneimage.svg";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ErrorImage from "../../Components/assets/Images/errorImage.svg";
import { SaveEsignPdfDDPIAPICall } from "./DDPIAPICalls";
import styles from "../../pages/Styles/Redirect.module.scss";
import { REDIRECTURL } from "../../shared/constants";

export default function SuccessDDPIEsignPage() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setloading] = useState(false);
  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const reqId = params.request_id;
  const state = params.state;
  const status = params.status;
  // console.log(params,"params");
  sessionStorage.setItem("access-token", state);
  // if (window.location.href.includes("Cancelled")) {
  //   console.log(window.location.href);
  // }

  function saveEsignDoc() {
    // let obj: any = {
    //   status: "success",
    //   doc_id: code,
    // };
    let obj: any = {
      request_id: reqId || "",
    };
    setloading(true);
    SaveEsignPdfDDPIAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);
        window.location.href = `${REDIRECTURL}ddpi/esign`;

        //  console.log("response", response);
      })
      .catch((error: any) => {
        setloading(false);
        window.location.href = `${REDIRECTURL}ddpi/esign`;

        setDisplayError(true);
      });
  }

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      // console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      saveEsignDoc();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={!displayError ? DoneImage : ErrorImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                    ? "Error fetching your Documents"
                    : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in ${countDown} seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
